/**
 * Gets the instantiated Router, if it exists.
 * @returns instantiated Router.
 */
export function getRouter() {
    var _a, _b;
    if (!((_b = (_a = window.SYDLE) === null || _a === void 0 ? void 0 : _a.router) === null || _b === void 0 ? void 0 : _b.instance)) {
        return null;
    }
    return window.SYDLE.router.instance;
}
